import React from "react";
export function ForminatorNumber(props) {
    const { placeholder, onChange, value = '', limit_min: min, limit_max: max, } = props;
    return React.createElement("input", Object.assign({ type: 'number', className: 'ltg-control', onChange: ({ target }) => { onChange(target.value); } }, { value, placeholder, min, max }));
}
